import React, { useState } from 'react';
import {Button, Grid, Popover, Typography} from "@mui/material";
import cls from './PlatbackRateButton.module.scss';

interface PlatbackRateButtonProps {
    playbackRate: number;
    onPlaybackRateChange: (rate: number) => void;

}

const PlatbackRateButton = ({ playbackRate, onPlaybackRateChange }: PlatbackRateButtonProps) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'playback-rate-popover' : undefined;

    return (
        <>
            <button className={cls.button} onClick={handleClick}>
                <span>{playbackRate}x</span>
            </button>

            <Popover
                open={open}
                id={id}
                onClose={handleClose}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
            >
                <Grid container direction='column-reverse'>
                    {[0.5, 1, 1.5, 2].map((rate) => (
                        <Button
                            key={rate}
                            onClick={() => {
                                onPlaybackRateChange(rate);
                                handleClose();
                            }}
                            variant='text'
                        >
                            <Typography color={rate === playbackRate ? "secondary" : "inherit"}>
                                {rate}X
                            </Typography>
                        </Button>
                    ))}
                </Grid>
            </Popover>
        </>
    );
};

export default PlatbackRateButton;